<div class="input-wrapper">
  <simple-date-picker *ngIf="customInputType == 'date' && singleDatePicker"
    [valueFromParent]="inputText" (onDateSelect)="handleDateSelect($event)">
  </simple-date-picker>
  <filter-date-range-picker *ngIf="customInputType == 'date' && !singleDatePicker" [singleDatePicker]="false"
    [showFilterUI]="true" customFormat="MMM DD, YYYY" [valueFromParent]="inputText"
    (onDateSelect)="handleDateSelect($event)"></filter-date-range-picker>
  <ng-container *ngIf="customInputType != 'date'">
    <input *ngIf="customInputType !== 'disabled'; else disabledInput" [type]="getInputType()" [(ngModel)]="inputText"
      (ngModelChange)="handleInputChange($event)" [placeholder]="placeholderText"
      [attr.maxlength]="maxLength !== undefined ? maxLength : null" (click)="stopPropagation($event)"
      class="custom-input">
    <ng-template #disabledInput>
      <div class="disabled-input">
        Enter Value
      </div>
    </ng-template>
  </ng-container>
</div>
